<div class="bg-white shadow-lg rounded p-4 w-full mx-auto">
    <div class="animate-pulse flex space-x-4">
        <div class="flex-1 space-y-2">
            <div class="h-3 w-1/4 bg-slate-200 rounded"></div>
            <div class="h-4 w-2/3 bg-slate-200 rounded"></div>
            <div class="space-y-2">
                <div class="flex flex-row gap-2 justify-start items-center">
                    <div class="h-6 w-6 bg-slate-200 rounded-full"></div>
                    <div class="h-4 w-1/4 bg-slate-200 rounded"></div>
                </div>
            </div>
        </div>
    </div>
</div>